import { Accordion } from 'react-bootstrap';
import { CommonProperties } from '../../../common/common.interfaces';
import '../../styles/beacon.css'
import { useMemo } from 'react';

interface BeaconTabAppsProperties extends CommonProperties {
  components: any[]
  funcs: any[]
  funcApps: any[]
}

export default function BeaconTabApps(props: BeaconTabAppsProperties){
  const view = useMemo(() => {
    return <>
      <Accordion defaultActiveKey={'0'} className='custom-accordion'>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>
            <span className='beacon-header'>FUNCTION APPS & FUNCTIONS</span>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              <span className='beacon-label'>There are {props.funcApps.length} function app(s) and {props.funcs.length} function(s) that meet the filter criteria.</span>
              <br/>
              <span className='beacon-header'>Functions</span>
              <div className='beacon-nav' style={{ fontSize: '12px', wordWrap: 'break-word' }}>
                {props.funcs.map((item, index) => (
                  <a 
                    key={`${index}-function-link`} 
                    className='beacon-link' 
                    href={`#${item.partitionKey}`} 
                  >
                    {item.rowKey}
                  </a>
                ))}
              </div>
              <hr/>
              <span className='beacon-header'>Function Apps</span>
              <div className='beacon-nav' style={{ fontSize: '12px', wordWrap: 'break-word' }}>
                {props.funcApps.map((item, index) => (
                  <a 
                    key={`${index}-function-app-link`} 
                    className='beacon-link' 
                    href={`#${item}`} 
                  >
                    {item}
                  </a>
                ))}
              </div>

            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      {props.components}
    </>
  }, [props])
  
  return view
}